"use strict";

exports.__esModule = true;
exports.default = void 0;
var _Symbol2 = _interopRequireDefault(require("./_Symbol.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol2.default ? _Symbol2.default.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
var _default = exports.default = cloneSymbol;